import React from "react";
import "./TestimonialsSection.css";

const testimonials = [
  {
    name: "Juliette",
    role: "Medeoprichter & Kraamverzorgster",
    text: "Mijn naam is Juliette, moeder van twee kinderen en medeoprichter van Kraamzorg Bee. Na mijn eigen ervaringen in het moederschap wist ik het meteen: dit is het werk dat echt bij mij past. Ik ben van nature rustig en zorgzaam, en die kwaliteiten neem ik mee in mijn werk. Met liefde en aandacht begeleid ik gezinnen in de kostbare eerste dagen na de geboorte.",
  },
  {
    name: "Rosalie",
    role: "Medeoprichter & Kraamverzorgster",
    text: "Mijn naam is Rosalie en ik ben medeoprichter van Kraamzorg Bee. Met veel liefde en toewijding begeleid ik gezinnen tijdens de bijzondere kraamtijd. Persoonlijke aandacht, rust en vertrouwen staan bij mij centraal. Ik stem de zorg af op jullie wensen en achtergrond, want elke kraamtijd is uniek.",
  },
];

const TestimonialsSection = () => {
  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        {/* Section Header */}
        <div className="testimonials-header">
          <h2 className="testimonials-title">
            Over ons
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-header">
                <div className="testimonial-info">
                  <h3 className="testimonial-name">{testimonial.name}</h3>
                  <p className="testimonial-role">{testimonial.role}</p>
                </div>
              </div>
              
              <div className="testimonial-content">
                <div className="quote-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z" fill="currentColor"/>
                  </svg>
                </div>
                <p className="testimonial-text">{testimonial.text}</p>
              </div>
              
              <div className="testimonial-decoration"></div>
              <div className="testimonial-card-hover-effect"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
